<template>
  <div :id="`base-selector-${name + $parent.$options.name}`" class="relative">
    <v-menu
      :offset-y="true"
      :close-on-content-click="closeMenuWhenIsClicked"
      :attach="
        attached ? `#base-selector-${name + $parent.$options.name}` : false
      "
      @input="
        clearSelectedBaseOptions();
        updateBaseOptionsFromValue();
      "
      max-width="none"
      :nudge-left="nudgeToTheLeft"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          outlined
          rounded
          :x-large="getPropsSizeForVBTN.xLarge"
          :large="getPropsSizeForVBTN.large"
          :small="getPropsSizeForVBTN.small"
          :x-small="getPropsSizeForVBTN.xSmall"
          v-on="on"
          :disabled="disabled"
          @click="
            setMenuPosition();
            closeMenuWhenIsClicked = false;
          "
          v-bind:class="{
            'active-search-input': activeButton
          }"
          class="text-capitalize text-subtitle-1 grey-border-color white--background"
          v-text="name"
        >
        </v-btn>
      </template>
      <v-card max-height="600px" width="320px">
        <v-card
          max-height="250px"
          :elevation="0"
          style="overflow-y:scroll"
          class="px-6"
        >
          <!-- CheckBoxs IF MULTIPLE === TRUE -->
          <v-row v-if="multiple" no-gutters class="mt-2 mb-5">
            <v-col
              v-for="option in this.baseOptions"
              :key="option.id"
              cols="12"
            >
              <v-checkbox
                :hide-details="true"
                v-model="option.isSelected"
                :error="!baseValue.length && oneValueRequired"
                :label="option.nameFr"
                color="primary"
                class="pt-0 text-capitalize"
              >
                <template v-slot:label>
                  <span
                    class="ml-2"
                    v-bind:class="{
                      'font-weight-bold grey--text text--darken-4':
                        option.isSelected
                    }"
                    v-text="option.nameFr"
                  ></span>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
          <!-- Radio Button IF MULTIPLE === FALSE -->
          <v-row v-else no-gutters class="mt-2 mb-5">
            <v-radio-group v-model="baseRadioOption">
              <v-radio
                v-for="(option, index) in this.baseOptions"
                :key="option.id"
                :label="option.nameFr"
                :error="!baseValue.length && oneValueRequired"
                color="primary"
                class="pt-0 text-capitalize"
                :value="index"
              >
                <template v-slot:label>
                  <span
                    class="ml-2"
                    v-bind:class="{
                      'font-weight-bold grey--text text--darken-4':
                        baseRadioOption === index
                    }"
                    v-text="option.nameFr"
                  ></span>
                </template>
              </v-radio>
            </v-radio-group>
          </v-row>
          <div
            v-show="!baseValue.length && oneValueRequired"
            v-text="$t('search.mediaSelector.selectAtLeastOneMedium')"
            class="text-caption mt-4"
            style="color:#FF5252"
          ></div>
        </v-card>
        <v-divider></v-divider>
        <div class="pa-2 d-flex justify-space-between">
          <v-btn
            text
            :disabled="!baseValue.length && oneValueRequired"
            v-text="$t('search.SearchThemeSelector.clear')"
            @click="clearSelectedBaseOptions()"
          >
          </v-btn>
          <v-btn
            :disabled="!baseValue.length && oneValueRequired"
            text
            color="secondary"
            v-text="$t('search.SearchThemeSelector.validate')"
            @click="
              updateValue();
              closeMenuWhenIsClicked = true;
            "
          >
          </v-btn>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
export default {
  name: "BaseSelector",
  props: {
    name: {
      type: String,
      required: true
    },
    multiple: {
      type: Boolean,
      required: true,
      default: () => false
    },
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    value: {
      type: Array,
      required: true,
      default: () => []
    },
    attached: {
      type: Boolean,
      default: () => false
    },
    oneValueRequired: {
      type: Boolean,
      required: true,
      default: () => false
    },
    styleIsActiveIfValueEgalOptions: {
      type: Boolean,
      required: true,
      default: () => false
    },
    buttonSize: {
      type: String,
      default: () => "medium"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      closeMenuWhenIsClicked: false,
      baseOptions: [],
      baseRadioOption: null,
      positionMenuClass: "",
      nudgeToTheLeft: 0
    };
  },
  computed: {
    baseValue() {
      const baseOptions = this.baseOptions.filter(
        option => option.isSelected == true
      );
      return baseOptions;
    },
    baseRadioValue() {
      return [this.baseOptions[this.baseRadioOption]];
    },
    activeButton() {
      if (this.value.length) {
        if (
          this.value.length === this.options.length &&
          !this.styleIsActiveIfValueEgalOptions
        ) {
          return false;
        }
        return true;
      }
      return false;
    },
    getPropsSizeForVBTN() {
      switch (this.buttonSize) {
        case "medium":
          return { xLarge: false, large: false, small: false, xSmall: false };
        case "x-small":
          return { xLarge: false, large: false, small: false, xSmall: true };
        case "x-large":
          return { xLarge: true, large: false, small: false, xSmall: false };
        case "small":
          return { xLarge: false, large: false, small: true, xSmall: false };
        case "large":
          return { xLarge: false, large: true, small: false, xSmall: false };
        default:
          return { xLarge: false, large: false, small: false, xSmall: false };
      }
    }
  },
  methods: {
    // Add isSelected to False to add reactivity for isSelected
    initializeBaseOptions() {
      const baseOptions = cloneDeep(this.options);
      for (let index = 0; index < baseOptions.length; index++) {
        baseOptions[index].isSelected = false;
      }
      this.baseOptions = baseOptions;
    },
    // edit BaseOptions isSelected when the object is also present in valueProp
    updateBaseOptionsFromValue() {
      for (let i = 0; i < this.baseOptions.length; i++) {
        for (let j = 0; j < this.value.length; j++) {
          if (this.value[j].id === this.baseOptions[i].id) {
            this.baseOptions[i].isSelected = true;
            this.baseRadioOption = i;
          }
        }
      }
    },
    // emit event of newValue
    updateValue() {
      if (this.multiple) {
        if (
          this.baseValue
            .map(x => x.id)
            .sort()
            .join() !=
          this.value
            .map(x => x.id)
            .sort()
            .join()
        ) {
          this.$emit("updateValue", this.baseValue);
        }
      } else {
        this.$emit(
          "updateValue",
          this.baseRadioValue[0] === undefined ? [] : this.baseRadioValue
        );
      }
    },
    // Remove all selected Value
    clearSelectedBaseOptions() {
      for (let index = 0; index < this.baseOptions.length; index++) {
        this.baseOptions[index].isSelected = false;
      }
      this.baseRadioOption = null;
    },
    setMenuPosition() {
      if (this.$vuetify.breakpoint.smAndDown) {
        const { left } = this.$el.getBoundingClientRect();
        if (left + 336 > window.innerWidth) {
          this.nudgeToTheLeft = left - (window.innerWidth - 336) / 2;
        } else {
          this.nudgeToTheLeft = 0;
        }
      }
    }
  },
  created() {
    this.initializeBaseOptions();
    this.updateBaseOptionsFromValue();
  },
  watch: {
    value() {
      this.clearSelectedBaseOptions();
      this.updateBaseOptionsFromValue();
    }
  }
};
</script>
<style lang="scss">
.white--background {
  background-color: white;
}
</style>
